import axios from '@/plugins/axios'

// initial state
const state = {
    layout: 'app-layout',
    popups: [],
}

const getters = {
    layout: state => state.layout,
    popups: state => state.popups,
}

const actions = {
    setLayout({ commit }, layout) {
        commit('SET_LAYOUT', layout)
    },

    syncPopups({ commit }) {
        axios.get('/popups').then(res => {
            commit('SET_POPUPS', res.data)
        })
    },
}

const mutations = {
    SET_LAYOUT(state, layout) {
        state.layout = layout
    },

    SET_POPUPS(state, popups) {
        state.popups = popups
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
